<template>
  <footer id="footer">
    <div class="wrap-footer-content footer-style-1">
      <div class="wrap-function-info">
        <div class="container">
          <ul>
            <li class="fc-info-item">
              <i class="fa fa-shopping-basket" aria-hidden="true"></i>
              <div class="wrap-left-info">
                <h3 class="fc-name">Amplo Mix de produtos</h3>
                <p class="fc-desc">Distribuição Nacional</p>
              </div>
            </li>
            <li class="fc-info-item">
              <i class="fa fa-truck" aria-hidden="true"></i>
              <div class="wrap-left-info">
                <h3 class="fc-name">Agilidade na Logística</h3>
                <p class="fc-desc">Um gerador a cada 2 minutos</p>
              </div>
            </li>
            <li class="fc-info-item">
              <i class="fa fa-laptop" aria-hidden="true"></i>
              <div class="wrap-left-info">
                <h3 class="fc-name">100% Online</h3>
                <p class="fc-desc">Pronta-entrega</p>
              </div>
            </li>
            <li class="fc-info-item">
              <i class="fa fa-address-book" aria-hidden="true"></i>
              <div class="wrap-left-info">
                <h3 class="fc-name">Treinamentos e Show Room</h3>
                <p class="fc-desc">para visitas</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!--End function info-->
      <div class="main-footer-content">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-sm-3 col-md-3 col-xs-12">
              <div class="wrap-footer-item">
                <h4 class="item-header">Conheça-nos</h4>
                <div class="item-content">
                  <div class="wrap-contact-detail">
                    <ul>
                      <li>
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <a class="link-term" target="_blank" href="https://descarbonizesolucoes.com.br/"
                          ><span class="desc">Informações Corporativas</span></a
                        >
                      </li>

                      <li>
                        <i class="fa fa-briefcase" aria-hidden="true"></i>
                        <a rel="noreferrer" class="link-term" target="_blank" :href="`${$SiteUrl}/portais/trabalhe-conosco`"
                          ><span class="desc">Trabalhe Conosco</span></a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
              <div class="wrap-footer-item">
                <h4 class="item-header">QUEREMOS AJUDÁ-LO</h4>
                <div class="item-content">
                  <div class="wrap-hotline-footer">
                    <div class="col-6 col-md-6">
                      <a :href="`${$SiteUrl}/institucional/faleconosco`" class="link-term"><span class="desc">Fale Conosco</span></a>
                      <a href="https://www.aldo.com.br/portais/aldo-crazy-card/#condicoes-comerciais" class="link-term"
                        ><span class="desc">Condições Comerciais</span></a
                      >
                      <a rel="nofollow" :href="`${$SiteUrl}/termos-de-uso`" class="link-term"><span class="desc">Termos de Uso</span></a>
                      <a rel="nofollow" :href="`${$SiteUrl}/termo-de-atendimento`" class="link-term"
                        ><span class="desc">Termo de Atendimento</span></a
                      >
                      <a rel="nofollow" :href="`${$SiteUrl}/assets/pdf/politica-de-privacidade.pdf`" class="link-term"
                        ><span class="desc">Política de Privacidade - LGPD</span></a
                      >
                      <a rel="nofollow" :href="`${$SiteUrl}/assets/pdf/politica-de-cookies.pdf`" class="link-term"
                        ><span class="desc">Política de Cookies</span></a
                      >
                    </div>
                    <div class="col-6 col-md-6">
                      <a rel="nofollow" :href="`${$SiteUrl}/politica-integrada-de-gestao`" class="link-term"
                        ><span class="desc">Politica Integrada de Gestão</span></a
                      >
                      <a rel="nofollow" class="link-term" target="_blank" href="/arquivos/CÓDIGO DE CONDUTA ÉTICA PROFISSIONAL - 2024.pdf"
                        ><span class="desc">Código de Conduta e Ética - Compliance</span></a
                      >
                      <a rel="nofollow" class="link-term" target="_blank" href="/arquivos/CÓDIGO DE ÉTICA E CONDUTA - FORNECEDORES.pdf"
                        ><span class="desc">Código de Conduta e Ética - Forncedores</span></a
                      >
                      <a rel="nofollow" href="https://www.aldo.com.br/loja/marcas" class="link-term"><span class="desc">Parceiros</span></a>
                      <a rel="nofollow" class="link-term" target="_blank" href="/arquivos/MANUAL-DE-ENTREGA_ALDO-SOLAR_A4_2024_V2_REVENDAS.pdf"
                        ><span class="desc">Manual de Orientação de Entregas</span></a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-3 col-md-3 col-xs-12">
              <div class="wrap-footer-item">
                <h4 class="item-header">OUVIDORIA</h4>
                <div class="item-content">
                  <div class="wrap-hotline-footer">
                    <div class="col-6 col-md-6"></div>
                    <a rel="nofollow" class="link-term" target="_blank" href="https://www.canalconfidencial.com.br/aldo/"
                      ><span class="desc">Canal Confidencial descarbonize@canalconfidencial.com.br Telefone: 0800 300 4473</span></a
                    >
                    <a rel="nofollow" class="link-term" target="_blank" href="https://www.youtube.com/watch?v=NpS0nQLU3qM"
                      ><span class="desc">Antissuborno e Anticorrupção</span></a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="selos-redes-sociais" class="row">
          <div class="selos-container">
            <!-- <a href="#" class="link-to-item" title="our application on google play store">
              <figure>
                <img src="/assets/images/gptw.jpg" alt="Selo Great Place to Work" title="Selo Great Place to Work" width="75" height="98" />
              </figure>
            </a> -->
            <a href="#" class="link-to-item" title="our application on google play store">
              <figure>
                <img
                  src="/assets/images/selo-nós-apoiamos-complexo-pequeno-príncipe-100-anos.jpg"
                  alt="Aldo Solar apoia o Hospital Pequeno Principe"
                  title="Aldo Solar apoia o Hospital Pequeno Principe"
                  width="100"
                  height="36"
                />
              </figure>
            </a>
            <div id="ra-verified-seal"></div>
          </div>
          <div class="redes-sociais-container">
            <h4 class="item-header">Siga-nos nas redes sociais</h4>
            <div class="wrap-list-item social-network">
              <ul>
                <li>
                  <a href="https://twitter.com/Aldo_Solar" target="_blank" rel="noopener noreferrer" class="link-to-item" title="twitter">
                    <i class="fa fa-twitter" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/AldoSolarDistribuidora"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="link-to-item"
                    title="facebook"
                  >
                    <i class="fa fa-facebook" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/aldosolar"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="link-to-item"
                    title="Linkedin"
                  >
                    <i class="fa fa-linkedin" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/aldosolaroficial/"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="link-to-item"
                    title="instagram"
                  >
                    <i class="fa fa-instagram" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/aldosolar" target="_blank" rel="noopener noreferrer" class="link-to-item" title="Youtube">
                    <i class="fa fa-youtube" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="selos-container">
            <a href="#" class="link-to-item" title="our application on apple store">
              <figure>
                <img
                  src="/assets/images/logo-membro-aldo-solar-mercado-solar-livre.png"
                  alt="Aldo Solar Membro associado Movimento Solar Livre"
                  title="Aldo Solar Membro associado Movimento Solar Livre"
                  width="100"
                  height="36"
                />
              </figure>
            </a>
            <a href="#" class="link-to-item" title="our application on apple store">
              <figure>
                <img
                  src="/assets/images/SELO-ABRADISTI_09-2021.png"
                  alt="Empresa Associada à Abradist"
                  title="Empresa Associada à Abradist"
                  width="120"
                  height="36"
                />
              </figure>
            </a>
            <a href="#" class="link-to-item" title="our application on google play store">
              <figure>
                <img src="/assets/images/absolar.png" alt="Empresa Associada à Absolar" title="Empresa Associada à Absolar" width="100" height="36" />
              </figure>
            </a>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div v-if="logado" class="container">
      <div class="back-link-box wrap-footer-item social-network">
        <h4 class="backlink-title">Acesso Rápido</h4>
        <div class="back-link-row">
          <ul class="list-back-link">
            <li><span class="row-title">Meus Pedidos:</span></li>
            <li>
              <a rel="nofollow" v-on:click="(e) => e.preventDefault()" :href="`${$SiteUrl}/loja/minha-conta/meus-pedidos/C`" class="redirect-back-link">Pedido de Venda Normal</a>
            </li>
            <li>
              <a rel="nofollow" :href="`${$SiteUrl}/loja/minha-conta/meus-pedidos/V`" class="redirect-back-link">Pedido de Venda Direta</a>
            </li>
            <li>
              <a rel="nofollow" :href="`${$SiteUrl}/loja/minha-conta/meus-pedidos/A`" class="redirect-back-link">Para Ativo Imobilizado</a>
            </li>
            <li>
              <a rel="nofollow" :href="`${$SiteUrl}/loja/minha-conta/download-danfe`" class="redirect-back-link">Download da Danfe</a>
            </li>
          </ul>
          <ul class="list-back-link">
            <li><span class="row-title">Financeiro:</span></li>
            <li>
              <a rel="nofollow" :href="`${$SiteUrl}/financeiro/boleto`" class="redirect-back-link">Boletos</a>
            </li>
            <li>
              <a rel="nofollow" :href="`${$SiteUrl}/financeiro/segundavia`" class="redirect-back-link">2ª via boletos</a>
            </li>
            <li>
              <a rel="nofollow" :href="`${$SiteUrl}/financeiro/comissao-venda-direta`" class="redirect-back-link">Comissão de Venda Direta</a>
            </li>
          </ul>
          <ul class="list-back-link">
            <li><span class="row-title">Serviços:</span></li>
            <li>
              <a rel="nofollow" :href="`${$SiteUrl}/loja/minha-conta/cadastro-venda-direta`" class="redirect-back-link"
                >Cadastro de Cliente para Venda Direta</a
              >
            </li>
            <li>
              <a rel="nofollow" :href="`${$SiteUrl}/loja/minha-conta/rma`" class="redirect-back-link">RMA Online</a>
            </li>
            <li>
              <a rel="nofollow" :href="`${$SiteUrl}/loja/minha-conta/cotacaoexpress`" class="redirect-back-link">Cotação Express</a>
            </li>
            <li>
              <a rel="nofollow" :href="`${$SiteUrl}/loja/minha-conta/importacao-produto`" class="redirect-back-link">Importação de Produtos</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="coppy-right-box" style="margin-top: 10px">
      <div class="container">
        <div class="coppy-right-item item-left">
          <p class="coppy-right-text">
            Descarbonize Soluções S/A
            <a href="#" rel="nofollow" class="link-to-home">Home</a>.
          </p>
        </div>
        <div class="coppy-right-item item-right">
          <div class="wrap-nav horizontal-nav">
            <ul>
              <li class="menu-item">
                <a rel="nofollow" href="#" class="link-term"
                  ><i
                    class="fa fa-map-marker"
                    style="
                      :hover {
                        color: white;
                      }
                    "
                    aria-hidden="true"
                  ></i>
                  Av. Advogado Horácio Raccanello Filho, 1836 - Maringá - PR - CEP 87.045-237
                </a>
              </li>
              <li class="menu-item">
                <a href="#" rel="nofollow" class="link-term"><i class="fa fa-phone" style="color: white" aria-hidden="true"></i> +55 44 3261-2000</a>
              </li>
              <li class="menu-item">
                <a href="#" rel="nofollow" class="link-term"
                  ><i class="fa fa-envelope" style="color: white" aria-hidden="true"></i> cartas@aldo.com.br</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'FooterDefault',
  data() {
    return {
      logado: false,
    }
  },
  mounted() {
    const self = this
    setTimeout(function () {
      let session = JSON.parse(localStorage.getItem('usuarioLogado'))
      if (session && session.DadosCliente != null) {
        self.logado = true
      }

      let reclameAquiScript = document.createElement('script')
      reclameAquiScript.setAttribute('src', 'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js')
      reclameAquiScript.setAttribute('id', 'ra-embed-verified-seal')
      reclameAquiScript.setAttribute('data-id', 'MTY4MzM6YWxkby1jb21wb25lbnRlcy1lbGV0cm9uaWNvcw==')
      reclameAquiScript.setAttribute('data-target', 'ra-verified-seal')
      reclameAquiScript.setAttribute('data-model', '1')
      document.head.appendChild(reclameAquiScript)
    }, 1000)
  },
}
</script>
